import Action from 'redux/helpers/createAction'
const name = 'app'

export const connectAppNotifications = Action(name + '/CONNECT_APP_NOTIFICATIONS')
export const disconnectAppNotifications = Action(name + '/DISCONNECT_APP_NOTIFICATIONS')
export const getAppNotifications = Action(name + '/GET_APP_NOTIFICATIONS', notifications => ({
  notifications
}))
export const readAppNotifications = Action(name + '/READ_APP_NOTIFICATIONS', uuids => ({
  uuids
}))
export const deleteAppNotification = Action(name + '/DELETE_APP_NOTIFICATION', uuid => ({
  uuid
}))

export const onOpenSideNav = Action(name + '/SIDENAV_OPEN')
export const onCloseSideNav = Action(name + '/SIDENAV_CLOSE')
export const onToggleSideNav = Action(name + '/SIDENAV_TOGGLE')
